<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Proveedores</li>
                <li class="breadcrumb-item active" aria-current="page">Catálogo de productos por verificar</li>
            </ol>
        </nav>
        
        <div class="container-fluid">
			<vx-card class="mb-5">
				<h1 class="bold big-title m-0">Verificación de <span>productos</span>.</h1>
			</vx-card>
            <vx-card title="Lista de modelos registrados" class="mb-5">
				<vs-table :data="modelsList" ref="modelsTable" stripe search noDataText="No se han generado registros" pagination :max-items="modelsPerPage">
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
						<vs-dropdown v-if="isMounted" vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
							<div class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              					<span class="mr-2">{{ currentModelsPage * modelsPerPage - (modelsPerPage - 1) }} - {{ modelsList.length - currentModelsPage * modelsPerPage > 0 ? currentModelsPage * modelsPerPage : modelsList.length }} de {{ queriedModelItems }}</span>
              					<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            				</div>
            				<vs-dropdown-menu>
              					<vs-dropdown-item v-for="it in itemsPerPageDefinitions" @click="modelsPerPage = it" :key="it">
                					<span>{{it}}</span>
              					</vs-dropdown-item>           
            				</vs-dropdown-menu>	
						</vs-dropdown>
					</div>

					<template slot="thead">
						<vs-th class="bold" sort-key="model">MODELO</vs-th>
						<vs-th class="bold" sort-key="brand">MARCA</vs-th>
						<vs-th class="bold" sort-key="product_group_name">FAMILIA DE PRODUCTOS</vs-th>
						<vs-th class="bold" sort-key="capacity">CAPACIDAD</vs-th>
						<vs-th class="bold" sort-key="capacity">SOLICITUD VERIFICACIÓN</vs-th>
						<vs-th class="bold" sort-key="capacity">VERIFICACIÓN</vs-th>
						<vs-th class="bold" sort-key="status">ESTATUS</vs-th>
						<vs-th class="bold" sort-key="TT">TT (DÍAS)</vs-th>
						<vs-th class="bold">SEM.</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(tableRow, index) in data">
							<vs-td :data="data[index].model">
                  				<vs-button type="line" @click="openViewModal(data[index])">{{ data[index].model }}</vs-button>
							</vs-td>

							<vs-td :data="data[index].product_brand_id">
								{{ data[index].brand_name }}
							</vs-td>

							<vs-td :data="data[index].product_group_id">
								{{ data[index].product_name }}
							</vs-td>

							<vs-td :data="data[index].capacity">
								{{ data[index].capacity }} {{ data[index].capacity_units }}
							</vs-td>

							<vs-td :data="data[index].verification_request_date">
								{{ data[index].verification_request_date }}
							</vs-td>

							<vs-td :data="data[index].verified_date">
								{{ data[index].verified_date }}
							</vs-td>

							<vs-td :data="data[index].status">
								<span :class="getModelStatusClass(data[index].status)">{{getModelStatusText(data[index].status)}}</span>
							</vs-td>

							<vs-td :data="data[index].TT">
								{{ data[index].TT }}
							</vs-td>

							<vs-td :data="getTriageColor(data[index].TT)">
								<div :class="`light ${getTriageColor(data[index].TT)}`"></div>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>

			<vs-popup title="Detalle" :active.sync="isViewModalShown" :style="{zIndex: 998}" class="con-vs-popup extended-popup">
				<div class="p-4">
					<vs-alert v-if="onError" class="h-full mb-5" color="danger">
            			<span>{{ errorMsg }}</span>
          			</vs-alert>

					<template v-if="currentModel">

						<div class="vx-row">
							<div class="vx-col w-full">
								<vx-card>
									<div class="vx-row">
										<div class="vx-col w-1/2">
											<h4 class="mt-4">{{ getViewModalTitle }}</h4>
										</div>
										<div class="vx-col w-1/2 flex align-center">
											<vs-button @click="handleEditModel()" type="line" color="primary" class="mr-10 mt-2">Guardar</vs-button>
											<vs-button @click="handleModelVerification(2)" :disabled="currentModel.status == 2" type="line" color="success" class="mr-5 mt-2">Verificar</vs-button>
											<vs-button @click="handleModelVerification(3)" :disabled="currentModel.status == 3" type="line" color="danger" class="mr-5 mt-2">Rechazar</vs-button>
										</div>
									</div>
								</vx-card>
							</div>
          				</div>

						<div class="vx-row mb-8">

							<div class="vx-col w-full">
								<vx-card title="Información general" class="mt-base">
									<div class="vx-row">
										<div class="vx-col w-1/2">
											<label class="vs-input--label">Sistema o tecnología</label>
											<v-select
												label="text"
												class="vs-custom w-full mb-5"
												v-model.lazy="selectedFamilyGroup"
												:options="familyGroupsList"
												:reduce="text => text.value"
												:clearable="false"
												:searchable="true"
												placeholder="Seleccione una opción">
												<div slot="no-options">No hay coincidencias</div> 
											</v-select>
										</div>
										<div class="vx-col w-1/2">
											<label class="vs-input--label">Grupo de productos</label>
											<v-select
												label="text"
												class="vs-custom w-full mb-5"
												v-model.lazy="selectedProductGroup"
												:options="getModalProductGroups"
												:reduce="text => text.value"
												:clearable="false"
												:searchable="true"
												placeholder="Seleccione una opción">
													<div slot="no-options">No hay coincidencias</div> 
											</v-select>
										</div>
									</div>
									<div class="vx-row">
										<div class="vx-col w-full">
											<label class="vs-input--label">Marca</label>
											<v-select
											label="text"
											class="vs-custom w-full mb-5"
											v-model.lazy="selectedProductBrand"
											:options="getModalProductBrands"
											:reduce="text => text.value"
											:clearable="false"
											:searchable="true"
											placeholder="Seleccione una opción" >
												<div slot="no-options">No hay coincidencias</div> 
											</v-select>
										</div>
									</div>
									<div class="vx-row">
										<div class="vx-col w-full">
											<vs-input
											class="w-full mb-4" 
											label="Nombre del modelo"
											placeholder="Requerido"
											data-vv-name="model"
											v-model.lazy="modelName" />
										</div>
									</div>
									<div class="vx-row">
										<div class="vx-col w-full">
											<vs-input
											class="w-full mb-4" 
											:label="`Capacidad - ${currentModel.capacity_units}`"
											placeholder="Requerido"
											data-vv-name="model"
											v-model.lazy="modelCapacity" />
										</div>
									</div>
								</vx-card>
							</div>

							<div class="vx-col w-full">
								<vx-card title="Verificación y ficha técnica" class="mt-base">
									<div class="vx-row">
										<div class="vx-col w-2/3">
											<div class="vx-row">
												<div class="vx-col w-full">
													<document-upload
														:key="currentModel"
														:f="dataSheetDocumentField"
														:doc="dataSheetDocument"
														:target_id="currentModel.id"
														:inputClassExtraLarge="true"
														:evaluator="getDataSheetDocumentData"
														:editableByBackoffice="true"
														:automatic="true" 
														:isGeneralDoc="true" 
													/>
												</div>
											</div>
										</div>
										<div class="vx-col w-1/3">
											<div class="vx-row">
												<div class="vx-col w-full my-4">
													<h4 class="text-warning">Verificación</h4>
												</div>
											</div>
											<div class="vx-row mb-3">
												<div class="vx-col w-full">
													<span>Estatus de verificación: </span><span :class="getModelStatusClass(currentModel.status)">{{getModelStatusText(currentModel.status)}}</span>
												</div>
											</div>
											<div class="vx-row mb-3" v-if="currentModel.verification_request_date">
												<div class="vx-col w-full">
													<span>Fecha de envio a verificación: </span><span :class="getModelStatusClass(currentModel.status)">{{currentModel.verification_request_date}}</span>
												</div>
											</div>
											<div class="vx-row mb-3" v-if="currentModel.status == 2 && currentModel.verified_date">
												<div class="vx-col w-full">
													<span>Fecha de verificación: </span><span :class="getModelStatusClass(currentModel.status)">{{currentModel.verified_date}}</span>
												</div>
											</div>
											<div class="vx-row mb-3" v-if="currentModel.supplier_tradename">
												<div class="vx-col w-full">
													<span>Enviado por: {{currentModel.supplier_tradename}}</span>
												</div>
											</div>
										</div>						
									</div>		
								</vx-card>
							</div>

						</div>
						<div class="vx-row">
							<div class="vx-col w-full">
								<vx-card title="Certificaciones" class="mt-base">
									<certifications-table
										ref="certificationsTableRef"
										:selectedCertificationsList="selectedCertificationsList"
										:certificationsList="certificationsList"
										:editable="true"
										:currentModel="currentModel" 
									/>
								</vx-card>
							</div>
						</div>

					</template>
				</div>
			</vs-popup>

        </div>
    </div>
</template>

<script>
import CertificationsTable from './CertificationsTable.vue';

export default {
	name: "VerifyProductsCatalog",
	components: {
		CertificationsTable
	},
	data() {
		return {
			isMounted: false,
			familyGroupsList: [],
			productsGroupList: [],
			brandsList: [],
			modelsList: [],
			currentModel: null,
			selectedFamilyGroup: null,
			modelName: null,
			modelCapacity: null,
			selectedProductGroup: null,
			selectedProductBrand: null,
			isViewModalShown: false,
			onError: false,
			errorMsg: null,
			modelsPerPage: 5,
			itemsPerPageDefinitions: [5, 10, 25, 50],
			selectedCertificationsList: [],
			certificationsList: [],
			redValue: 0,
			yellowValue: 0,

			dataSheetDocument: null,
			// Nota: si cambias doc_assoc.table/assoc_key aquí, también debe actualizarse
			// ALLOWED_ASSOC_TABLE_KEYS en DocumentManagerController.php (backend),
			// o la asociación será rechazada con HTTP 400.
			dataSheetDocumentField: {
				doc_id: 171,
				field_name: 'Ficha técnica',
				extras: JSON.stringify({
					doc_assoc: {
						table: 'product_models',
						assoc_key: 'id',
						condition: 'getDataSheetCondition'
					}
				})
			}

		}
	},
	async mounted() {
		this.showLoading(true);
		await this.getFamilyGroupsList();
		await this.getProductGroupsList();
		await this.getBrandsList();
		await this.getModelsList();
		await this.getCertificationsList();
		await this.getDataSheetDocument();
		await this.getSlasValues();
		this.isMounted = true;
		this.showLoading(false);
	},
	computed: {
		currentModelsPage () {
			if (this.isMounted)
				return this.$refs.modelsTable.currentx;
			return 0;
		},
		queriedModelItems () {
			return this.$refs.modelsTable ? this.$refs.modelsTable.queriedResults.length : this.modelsList.length
		},
		getViewModalTitle() {
      		if(this.isViewModalShown)
        		return `Modelo ${this.currentModel.model} (${this.currentModel.brand_name})`;
    	},
		getModalProductGroups() {
			this.selectedProductGroup = null;
			if(this.currentModel && !this.currentModel.isSet)
				this.selectedProductGroup = this.currentModel.product_group_id;

			let collection = this.productGroupsList.filter((productGroup) => productGroup.family_group_id == this.selectedFamilyGroup);
			return collection.map((productGroup) => ({ value: productGroup.id, text: productGroup.name }));
		},
		getModalProductBrands() {
			this.selectedProductBrand = null;
			if(this.currentModel && !this.currentModel.isSet) {
				this.selectedProductBrand = this.currentModel.product_brand_id;
				this.currentModel.isSet = true;
			}

			let collection = this.brandsList.filter((brand) => brand.product_group_id == this.selectedProductGroup);
			return collection.map((brand) => ({ value: brand.id, text: brand.brand }));
		},
	},
	watch: {
		isViewModalShown(newValue) {
			if(!newValue) {
				this.currentModel = null;
				this.selectedCertificationsList = [];
				return;
			}
			this.getModelCertificationsList();
		},
	},
	methods: {
		async handleEditModel() {
			try {
				this.showLoading(true);
				await this.$refs.certificationsTableRef.handleOnSave();
				let {data} = await axios.put(`/api/v1/supplier/models/${this.currentModel.id}`, {
					productBrandId: this.selectedProductBrand,
					modelName: this.modelName,
					capacity: this.modelCapacity
				});
				if(data)
					this.currentModel = data.productModel;

				await this.getModelsList();
			} 
			catch (error) {
				console.log(error);
				this.warn(error);
			}
			this.showLoading(false);
		},
		async handleModelVerification(status) {
			try {
				this.showLoading(true);
				const {data} = await axios.put(`/api/v1/supplier/models/${this.currentModel.id}/status`, { status });
				if(data) {
					await this.getModelsList();
					this.currentModel = this.modelsList.find((model) => model.id == this.currentModel.id);
				}
				this.showLoading(false);
			}
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
			this.showLoading(false);
		},
		async getFamilyGroupsList() {
			try {
				const {data} = await axios.get('/api/v1/forms/getFamilyGroups');
				if(data)
					this.familyGroupsList = data.map((familyGroup) => ({ value: familyGroup.id, text: familyGroup.name }));
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
		async getProductGroupsList() {
			try {
				const {data} = await axios.get('/api/v1/forms/getProductGroups');
				if(data)
					this.productGroupsList = data;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
		async getBrandsList() {
			try {
				const {data} = await axios.get('/api/v1/supplier/getProductBrands');
				if(data)
					this.brandsList = data;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;
			}
		},
		async getModelsList() {
			try {
				const {data} = await axios.get('/api/v1/supplier/models/pending');
				if(data)
					this.modelsList = data;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
		getModelStatusText(status) {
			switch(status) {
				case 1: return 'Verificación pendiente';
				case 2: return 'Verificado';
				case 3: return 'Rechazado';
			}
		},
		getModelStatusClass(status) {
			switch(status) {
				case 1: return 'text-warning';
				case 2: return 'text-success';
				case 3: return 'text-danger';
			}
		},
		openViewModal(productModel) {
			this.currentModel = productModel;
			this.selectedFamilyGroup = this.currentModel.family_group_id;
			this.selectedProductGroup = this.currentModel.product_group_id;
			this.selectedProductBrand = this.currentModel.product_brand_id;
			this.modelName = this.currentModel.model;
			this.modelCapacity = this.currentModel.capacity;
			this.isViewModalShown = true;
		},
		getDataSheetDocumentData(condition) {
			if(condition != null && condition in this)
				return this[condition]();
		},
		getDataSheetSource() {
			return this.currentModel?.id;
		},
		getDataSheetCondition() {
			return true;
		},
		async getDataSheetDocument() {
			this.dataSheetDocument = await this.getDocumentById(171);
		},
		async getDocumentById(documentId) {
			try {
				let result = await axios.get(`/api/v1/forms/document/${documentId}`);
				if(result && result.data)
				return result = result.data.document;
			} 
			catch (error) {
				this.warn(error);
				this.onError = true;
			}
		},
		async getCertificationsList() {
			try {
				const {data} = await axios.get('/api/v1/certifications');
				if(data)
					this.certificationsList = data;
			} 
			catch (error) {
				this.warn(error);
				this.failed = true;				
			}
		},
		async getModelCertificationsList() {
			try {
				const {data} = await axios.get(`/api/v1/certifications/model/${this.currentModel.id}`);
				if(data)
					this.selectedCertificationsList = data.message;
			} 
			catch (error) {
				this.warn(error);
        		this.failed = true;				
			}
		},
		async getSlasValues() {
			try {
      			const {data} = await axios.get('/api/sla_df_verification');
				this.redValue = parseInt(data.sla_verified[0].val);
				this.yellowValue = parseInt(data.sla_verified[1].val);
			}
			catch (error) {
				this.warn(error);
				this.failed = true;	
			}
		},
		getTriageColor(TT) {
			if(TT >= this.redValue)
				return 'l-2';
			else if(TT >= this.yellowValue)
				return 'l-1';
			return 'l-0';
		}
	}
}
</script>

<style scoped>
	.light {
		height: 25px;
		width: 25px;
		border-radius: 50%;
	}

	.light.l-0 {
		background-color: rgba(var(--vs-success), 1);
	}

	.light.l-1 {
		background-color: rgba(var(--vs-warning), 1);
	}

	.light.l-2 {
		background-color: rgba(var(--vs-danger), 1);
	}

	.align-center {
		align-items: right;
	  	justify-content: right;
	}
</style>
